import { useEffect } from 'react'
import { navigate } from "@reach/router"
import { isCartillaSubdomain } from '../utils/links'

// Componente para redirigir / a /ar solo en app.wiri.la, NO en cartilla
const RootRedirect = () => {
  useEffect(() => {
    // Solo redirigir si NO estamos en cartilla
    if (!isCartillaSubdomain()) {
      navigate('/ar', { replace: true })
    }
  }, [])
  return null
}

export default RootRedirect
